import React from 'react'
import { Navigate, Outlet } from 'react-router'

import { Routes } from '@/lib/routes'

import { RestrictedMobileAppContent } from './RestrictedMobileAppContent'

export function RestrictedMobileAppRoute() {
	return (
		<RestrictedMobileAppContent fallback={() => <Navigate to={Routes.Home} />}>
			<Outlet />
		</RestrictedMobileAppContent>
	)
}
